import React, { useState, useEffect } from "react";
import { Grid, Typography, Box, useTheme } from "@mui/material";
import { useDepthChart } from "../../../../contexts/DepthChartContext";
import { useLogger } from "../../../../contexts/LoggerContext";
import {
  calculateKickoffYardage,
  calculateReturnYardage,
} from "../../../../helpers/helpers";
import { PlayerSelection } from "../Components/PlayerSelection";
import { RosterPlayer } from "../../../../types/LogTypes";
import { YardlineInput } from "../Components/YardlineInput";

export const PuntReturnLog = () => {
  const [selectedReturner, setSelectedReturner] = useState<RosterPlayer | null>(
    null
  );
  const [jerseyNumber, setJerseyNumber] = useState<string>("");
  const [ballCaughtOn, setBallCaughtOn] = useState<number>(0);
  const [ballReturnedTo, setBallReturnedTo] = useState<number>(-20);
  const [puntFrom, setPuntFrom] = useState<number>(40);
  const returnYardage = calculateReturnYardage(ballCaughtOn, ballReturnedTo);
  const puntYardage = calculateKickoffYardage(puntFrom, ballCaughtOn);
  const { puntReturnPlayers } = useDepthChart();
  const { setCurrentPlayLog, clearSelections } = useLogger();
  const theme = useTheme();

  const handleJerseyNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    if (value === "" || (parseInt(value) >= 0 && parseInt(value) <= 99)) {
      setJerseyNumber(value);
    }
  };

  const handleReturnerSelection = (player: RosterPlayer) => {
    setSelectedReturner(player);
    setJerseyNumber(player.jersey_number?.toString() || "");
  };

  useEffect(() => {
    if (selectedReturner) {
      setCurrentPlayLog({
        returner_roster_player: selectedReturner,
        punt_from: puntFrom,
        punt_to: ballCaughtOn,
        punt_yardage: puntYardage,
        return_to_yardline: ballReturnedTo,
        return_yardage: returnYardage,
      });
    }
  }, [selectedReturner, puntFrom, ballCaughtOn, ballReturnedTo]);
  
  useEffect(() => {
    if (clearSelections) {
      setSelectedReturner(null);
      setJerseyNumber("");
      setBallCaughtOn(0);
      setBallReturnedTo(-20);
      setPuntFrom(40);
    }
  }, [clearSelections]);
  
  return (
    <Box>
      <Grid container>
        {/* Returner */}
        <Grid item xs={3}>
          <PlayerSelection
            title="Returner"
            players={puntReturnPlayers}
            selectedPlayer={selectedReturner}
            jerseyNumber={jerseyNumber}
            maxDisplayedPlayers={1}
            handlePlayerSelection={handleReturnerSelection}
            handleJerseyNumberChange={handleJerseyNumberChange}
          />
        </Grid>

        {/* Ball Spots */}
        <Grid item xs={9}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 0,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <YardlineInput
                value={puntFrom}
                onChange={setPuntFrom}
                label="Punt From"
              />

              <YardlineInput
                value={ballCaughtOn}
                onChange={setBallCaughtOn}
                label="Ball Caught On"
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 0,
              }}
            >
              <YardlineInput
                value={ballReturnedTo}
                onChange={setBallReturnedTo}
                label="Ball Returned To"
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
